import { render, staticRenderFns } from "./ExpectedUsageIcon.vue?vue&type=template&id=6a83feca&"
import script from "./ExpectedUsageIcon.vue?vue&type=script&lang=ts&"
export * from "./ExpectedUsageIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports